module.exports = __webpack_public_path__ + "static/img/2.3bed823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R290/2.jpg
// module id = jrzR
// module chunks = 1